import React from 'react';

import {MenuItem, SelectChangeEvent} from "@mui/material";
import {SortFilterInputLabel} from "../../reports/sortFilter/SortFilterInputLabel";
import {SortFilterSelect} from "../../reports/sortFilter/SortFilterSelect";
import {FormControlStandard, FormInputItemFlexContainer, FormInputItemFullWidthContainer } from "@securspace/securspace-ui-kit";

import {SelectInputProps} from "../../../SortFilter/interfaces";

type BoundSelectProps<T> =  {
  options: SelectInputProps[];
  name: string;
  value?: string | number | null;
  label: string;
  onChange: (newQuery: T) => void;
}

const BoundSelect = <T,>({
  options,
  name,
  value = '',
  label,
  onChange
}: BoundSelectProps<T>) => {

  const handleChange = (event: SelectChangeEvent) => {
    onChange({
      [name]: event?.target?.value ?? ''
    } as unknown as T);
  }

  return (
    <FormInputItemFlexContainer>
      <FormInputItemFullWidthContainer>
        <FormControlStandard>
          <SortFilterInputLabel>{label}</SortFilterInputLabel>
          <SortFilterSelect
            onChange={handleChange}
            value={value == null ? '' : String(value)}
          >
            {
              options.map((option, index) => (
                <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
              ))
            }
          </SortFilterSelect>
        </FormControlStandard>
      </FormInputItemFullWidthContainer>
    </FormInputItemFlexContainer>
  )
};

export { BoundSelect };